import React from 'react';

import { Platform, ViewStyle } from 'react-native';

import Animated, { useAnimatedStyle } from 'react-native-reanimated';

import { FloatingCellProps } from '../types';
import FloatingCellMobile from './FloatingCellMobile';
import FloatingCellTV from './FloatingCellTV';

const FloatingCell = (props: FloatingCellProps) => {
    const { config, rect, xVisibleStartOffset, onSelect } = props;

    const animatedStyle = useAnimatedStyle(
        () =>
            ({
                transform: [
                    {
                        // On web this is not smooth, as reanimated runs purely on JS side
                        // Consider to adjust text position to sticky on client side.
                        translateX:
                            Platform.OS === 'web'
                                ? 0
                                : xVisibleStartOffset.value,
                    },
                ],
                width: rect.width,
                height: config.rowHeight + config.padding,
            } as ViewStyle),
        [rect.width],
    );

    return (
        <Animated.View style={animatedStyle}>
            {Platform.isTV ? (
                <FloatingCellTV {...props} onFocus={onSelect} />
            ) : (
                <FloatingCellMobile {...props} />
            )}
        </Animated.View>
    );
};

export default FloatingCell;
